// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__7500W","errorLogs":"EditorFooter_errorLogs__3YLGQ"};